import { useEffect } from "react";
import { motion } from "framer-motion";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const JAR_START = { scale: 0.4, rotate: -12 };
const JAR_END = { scale: 1, rotate: 0 };
const JAR_SPRING = { type: "spring", stiffness: 160, damping: 10 };
const NUT_START = { y: -120, opacity: 0 };
const NUT_END = { y: 0, opacity: 1 };
import { playChime } from "@/lib/chime";
import { speak } from "@/lib/api";

const MESSAGES = {
  10: "Ten acorns! Your kind words are starting to grow.",
  25: "Twenty-five acorns! Your kindness is becoming a strong little tree.",
  50: "Fifty acorns! You're growing a whole forest of kindness.",
};

export const MilestoneCelebration = ({ milestone, name, onClose }) => {
  const open = Boolean(milestone);
  useEffect(() => {
    if (!open) return;
    playChime(true);
    const t = setTimeout(() => speak(`${name ? name + ", y" : "Y"}our acorn jar reached ${milestone}! ${MESSAGES[milestone]}`), 900);
    return () => clearTimeout(t);
  }, [open, milestone, name]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="pp-milestone" data-testid="milestone-dialog">
        <motion.div className="pp-milestone-jar" initial={JAR_START} animate={JAR_END}
          transition={JAR_SPRING}>
          {Array.from({ length: 5 }, (_, i) => (
            <motion.img key={i} src="/acorn-t.png" alt="" style={{ left: `${10 + i * 16}%` }}
              initial={NUT_START} animate={NUT_END} transition={{ delay: 0.3 + i * 0.12 }} />
          ))}
          <span className="pp-milestone-num" data-testid="milestone-number">{milestone}</span>
        </motion.div>
        <DialogTitle className="pp-h2 text-center">{name ? `${name}'s` : "Your"} acorn jar reached {milestone}!</DialogTitle>
        <DialogDescription className="text-center text-base" data-testid="milestone-message">{MESSAGES[milestone]}</DialogDescription>
        <button className="pp-primary mx-auto" onClick={onClose} data-testid="milestone-close-button">Keep growing</button>
      </DialogContent>
    </Dialog>
  );
};
